import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { SalesInsightsDashboardDefinition, SalesInsightsFilterValues } from '../models/sales-insights.model';

export interface SalesInsightsPageActionContext {
  definition: SalesInsightsDashboardDefinition;
  filters: SalesInsightsFilterValues;
  isAdmin: boolean;
  reload: () => void;
}

export interface SalesInsightsPageAction {
  action: string;
  labelKey: string;
  icon?: string;
  adminOnly?: boolean;
  run: (context: SalesInsightsPageActionContext) => Observable<unknown> | Promise<unknown> | void;
}

export const SALES_INSIGHTS_PAGE_ACTIONS = new InjectionToken<Array<SalesInsightsPageAction | SalesInsightsPageAction[]>>(
  'SALES_INSIGHTS_PAGE_ACTIONS'
);
